import React from 'react'

export const ExitFullScreen: React.FC = () => (
  <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        transform="translate(7.000000, 6.500000) scale(-1, -1) translate(-7.000000, -6.500000) translate(4.000000, 3.500000)"
        fill="currentColor"
      >
        <rect x="0" y="0.5" width="1" height="5" />
        <rect
          transform="translate(3.500000, 1.000000) rotate(90.000000) translate(-3.500000, -1.000000) "
          x="3"
          y="-1.5"
          width="1"
          height="5"
        />
      </g>
      <g
        transform="translate(7.000000, 17.500000) scale(-1, 1) translate(-7.000000, -17.500000) translate(4.000000, 14.500000)"
        fill="currentColor"
      >
        <rect x="0" y="0.5" width="1" height="5" />
        <rect
          transform="translate(3.500000, 1.000000) rotate(90.000000) translate(-3.500000, -1.000000) "
          x="3"
          y="-1.5"
          width="1"
          height="5"
        />
      </g>
      <g transform="translate(14.000000, 14.500000)" fill="currentColor">
        <rect x="0" y="0.5" width="1" height="5" />
        <rect
          transform="translate(3.500000, 1.000000) rotate(90.000000) translate(-3.500000, -1.000000) "
          x="3"
          y="-1.5"
          width="1"
          height="5"
        />
      </g>
      <g
        transform="translate(17.000000, 6.500000) scale(1, -1) translate(-17.000000, -6.500000) translate(14.000000, 3.500000)"
        fill="currentColor"
      >
        <rect x="0" y="0.5" width="1" height="5" />
        <rect
          transform="translate(3.500000, 1.000000) rotate(90.000000) translate(-3.500000, -1.000000) "
          x="3"
          y="-1.5"
          width="1"
          height="5"
        />
      </g>
    </g>
  </svg>
)
